import axios from 'axios';

// Create an instance of Axios
const axiosInstance = axios.create();

// Add a response interceptor
axiosInstance.interceptors.response.use(
  response => response, // Pass through successful responses
  error => {
    if (error.response) {
      if (error.response.status === 401) {
        // Redirect to login page if a 401 response is received
        window.location.href = '/login';
      } else if (error.response.status === 403) {
        window.location.href = '/unauthorized';
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;